import React from 'react';
import ArrowTooltips from '../../ToolTip';
import Dot from '../../Dot';
import trainingIcon from '../../../images/TrainingFolder.png';
import baselineIcon from '../../../images/baseline.png';
import '../Style/ImageAmount.css';
import {IPropsView} from '../Config/ImageAmount.types';
import utilService from '../../../services/utilService';

const ImageAmount = ({toolTipTitle, isError, amount, type = 'training'}: IPropsView) => (
    <>
        {amount !== null && <ArrowTooltips designedTooltip='preEvaluation' title={toolTipTitle} placement='bottom' >
            <div className='query-box-eval-container'>
                {isError && <Dot color='red' size='small' position='eval'/>}
                <img src={type === 'training' ? trainingIcon : baselineIcon} alt='training icon' className='query-box-eval-training-img' />
                <p className='query-box-eval-amount'>{utilService.nFormatter(amount)}</p>
            </div>
        </ArrowTooltips>}
    </>
);

export default ImageAmount;
